import React from 'react';
import { CTAButton } from './CTAButton';
import { BOX_IMAGE, CHECKOUT_URL } from '../data/atlas';
export function FinalCTA() {
  return <section className="border-t-8 border-teal bg-navy px-4 py-7 text-center sm:py-9" data-id="element-51" data-mp="3udyitut58tm7">
      <div className="mx-auto max-w-3xl" data-id="element-52" data-mp="c7k4huqyqhna">
        <p className="text-[10px] font-extrabold uppercase tracking-[0.2em] text-teal sm:text-xs" data-id="element-53" data-mp="8570barv6rsm">
          One last question
        </p>

        <p className="mx-auto mt-2 max-w-2xl text-sm font-medium leading-snug text-ice sm:text-base" data-id="element-54" data-mp="m3wx0parupgg">
          How many times have you opened your Prosthodontics notes and thought:{' '}
          <em className="font-bold not-italic text-white" data-id="element-55" data-mp="vv1bzp0g6aba">
            “How am I supposed to organize all of this?”
          </em>{' '}
          You can keep jumping between textbooks, lecture notes, diagrams and scattered
          resources trying to connect everything. Or you can open one organized visual
          system. Choose the topic. See the map. Understand the relationships. Review what
          matters.
        </p>

        <h2 className="mt-4 text-2xl leading-none text-white sm:text-3xl" data-id="element-56" data-mp="2c67rwocwdk8i">
          🦷 PROSTHODONTICS VISUAL ATLAS™
        </h2>
        <p className="mt-1 text-xs font-extrabold uppercase tracking-wide text-ice sm:text-sm" data-id="element-57" data-mp="2h5knbxhu3zmp">
          The complete visual study system for dental students
        </p>
        <p className="mt-0.5 text-xs font-bold uppercase tracking-wide text-teal" data-id="element-58" data-mp="2r3iaehnyjqdq">
          Dentures • RPDs • Fixed • Implants • Occlusion • Materials
        </p>

        <a href={CHECKOUT_URL} className="mt-3 block" data-id="element-59" data-mp="301tzugd38i4l">
          <img src={BOX_IMAGE} alt="PROSTHODONTICS VISUAL ATLAS™ complete system" className="mx-auto w-full max-w-[180px] drop-shadow-2xl transition-transform duration-200 ease-soft hover:scale-[1.02]" data-id="element-60" data-mp="30093qmb4kr4m" />
        </a>

        <p className="mt-3 text-sm font-extrabold uppercase tracking-wide text-white" data-id="element-61" data-mp="3est2zbv5megs">
          🔥 Get the complete system today
        </p>

        <CTAButton className="mx-auto mt-2 max-w-md" data-id="element-62" data-mp="3iqqrsdl0iyjn">
          🦷 YES! I WANT PROSTHODONTICS VISUAL ATLAS™
        </CTAButton>

        <p className="mt-2 text-xs font-bold text-ice" data-id="element-63" data-mp="1eps7554fbskr">
          Immediate Access • Digital Delivery 🛡️ 14-Day Money-Back Guarantee
        </p>
      </div>
    </section>;
}